export const INVALID_ID = -1;



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/constants/ap_id_constants.ts